/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type LiabilityItemLiabilitySubType = (typeof LiabilityItemLiabilitySubType)[keyof typeof LiabilityItemLiabilitySubType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LiabilityItemLiabilitySubType = {
  mortgage: "mortgage",
  building_saving: "building_saving",
  consumer: "consumer",
  credit_card: "credit_card",
  overdraft: "overdraft",
  other: "other",
} as const;
